<template>
  <div class="model-frame">
    <el-row>
      <div class="model-header">
        <h2>Liên hệ</h2>
      </div>
    </el-row>
    <el-row>
      <div class="model-filter">
        <el-col :span="4">
          <el-select v-model="filter.status" filterable clearable placeholder="Trạng thái" class="input-select">
            <el-option v-for="item in lists.listStatus" :key="item.key" :label="item.value" :value="item.key">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="13">
          <el-popover placement="bottom" title="Sắp xếp theo" width="400" trigger="click" content="Nội dung">
            <div class="model-filter-radio" v-for="(item, index) in sort" :key="index">
              <span>{{ item.groupName }}:</span>
              <el-radio v-for="(itemSort, index_itemSort) in item.groupFiled" :key="index_itemSort" v-model="filter.sort"
                :label="itemSort.label">{{ itemSort.text }}</el-radio>
            </div>
            <span class="model-filter-search" slot="reference">
              <i class="fas fa-sort"></i>
            </span>
          </el-popover>
        </el-col>
        <el-col :span="1"></el-col>
        <el-col :span="5">
          <el-input placeholder="Tìm kiếm ..." class="input-seach" clearable
            :prefix-icon="searching ? 'fas fa-spinner fa-spin' : 'el-icon-search'" v-model="filter.q">
          </el-input>
        </el-col>
      </div>
    </el-row>
    <el-row>
      <div class="model-pagination">
        <el-pagination background layout="prev, pager, next" :page-size="table.pagination.per_page"
          :pager-count="table.pagination.count" :current-page="table.pagination.current_page"
          :total="table.pagination.total" @current-change="changeCurrentPage">
        </el-pagination>
        <div>
          Hiển thị tới liên hệ <strong>{{ table.meta_pagination }}</strong> / Tổng số: <strong>{{ table.pagination.total
          }}</strong> liên hệ
        </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-table">
        <el-table v-loading="loading" border :data="table.database" style="width: 100%">
          <el-table-column label="#" type="index" width="40">
          </el-table-column>
          <!--           <el-table-column
            width="200"
            label="Họ và tên">
            <template slot-scope="scope">
              <div class="courses-info">
                <div class="courses-info__item">
                  <span style="color: #c0392b">
                    {{ scope.row.name }}
                  </span>
                </div>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column width="200" label="Email">
            <template slot-scope="scope">
              <div class="courses-info">
                <div class="courses-info__item">
                  <span style="color: #c0392b">
                    {{ scope.row.email }}
                  </span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="content" label="Nội dung">
            <template slot-scope="scope">
              <div class="courses-info" v-if="scope.row">
                <span>Họ và tên: {{ scope.row.name }}</span>
                <span>Ngày sinh: {{ scope.row.birthday }}</span>
                <span>Số điện thoại: {{ scope.row.phone }}</span>
                <span>Email: {{ scope.row.email }}</span>
                <span>Trường tốt nghiệp gần nhất: {{ scope.row.school }}</span>
                <span>Hệ đào tạo: {{ scope.row.level_name }}</span>
                <span>Tỉnh thành phố: {{ scope.row.city }}</span>
                <span>Địa chỉ liên hệ: {{ scope.row.address }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="150" label="Số may mắn">
            <template slot-scope="scope">
              <span>
                {{ scope.row.lucky_number }}
              </span>
            </template>
          </el-table-column>
          <el-table-column width="150" label="Mã giới thiệu">
            <template slot-scope="scope">
              <span>
                {{ scope.row.code }}
              </span>
            </template>
          </el-table-column>
          <el-table-column width="150" label="Thời gian">
            <template slot-scope="scope">
              <span>
                {{ scope.row.created_at }}
              </span>
            </template>
          </el-table-column>

          <el-table-column width="150" label="Trạng thái">
            <template slot-scope="scope">
              <div v-if="scope.row.status" class="item_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
              <div v-else class="item_not_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Kích hoạt" width="80" align="center">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#7f8c8d"
                @change="changeStatus(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column width="150" label="Số người giới thiệu">
            <template slot-scope="scope">
              <span>
                {{ scope.row.number_of_introductions }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head, findIndex } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'Courses',
  metaInfo() {
    return {
      title: 'Liên hệ'
    }
  },
  data() {
    return {
      loading: false,
      searching: false,
      filter: {
        q: '',
        page: 1,
        limit: 15,
        sorted: '',
      },
      sort: [
        {
          groupName: 'Không sắp xếp',
          groupFiled: [
            { label: '', text: 'Không sắp xếp' }
          ]
        },
        {
          groupName: 'Thời gian',
          groupFiled: [
            { label: 'created_at:-1', text: 'Tăng dần' },
            { label: 'created_at:1', text: 'Giảm dần' }
          ]
        }
      ],
      lists: {
        listStatus: [
          { key: 1, value: 'Đã tiếp nhận' },
          { key: 0, value: 'Chưa tiếp nhận' }
        ],
        listCourses: [
          { key: 0, value: 'Chọn khóa học' }
        ],
        listLessons: [

        ]
      },
      table: {
        database: [],
        meta_pagination: 0,
        pagination: {
          total: 0,
          count: 0,
          per_page: 0,
          current_page: 1,
          total_pages: 0
        },
        timer: {}
      }
    }
  },
  mounted() {
    this.configBreadcrumb()
    // this.fetchListCourse()
    this.fetchDatabaseModel()
  },
  methods: {
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb() {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'luckywheel-index', text: 'Vòng quay may mắn' }
      ]
      this.setBreadcrumb(breadcrumb)
    },

    changeStatus(model) {
      let dataUpdate = {
        'status': model.status ? 1 : 0
      }
      axios.post('luckywheels/update-status/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Đã tiếp nhận' : 'Chưa tiếp nhận'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // Fetch dữ liệu về lĩnh vực danh sách khóa học
    fetchListCourse() {
      axios.get('courses', { params: { 'status': 1, 'limit': -1 } }).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listCourses = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về lĩnh vực danh sách bài học
    fetchListLesson() {
      axios.get('lessons', { params: { 'status': 1, 'limit': -1, 'course_id': this.filter.course_id } }).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listLessons = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu
    fetchDatabaseModel() {
      this.loading = true
      axios.get('luckywheels', { params: this.filter }).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.table.database = response.data
            this.table.pagination = response.meta.pagination
            this.caculaterMetaPagination()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tính trường số bản ghi xem nó đang hiện đến bao nhiêu
    caculaterMetaPagination() {
      if (this.table.pagination.current_page === this.table.pagination.total_pages) {
        this.table.meta_pagination = (this.table.pagination.current_page - 1) * this.table.pagination.per_page + this.table.pagination.count
      } else {
        this.table.meta_pagination = this.table.pagination.current_page * this.table.pagination.per_page
      }
    },
    // Xem chi tiết
    showModel(model) {
      this.$router.push({ name: 'contacts-show', params: { course_id: model.id } })
    },
    // Đổi trạng thái kích hoạt / không kích hoạt

    // confirmDeleteModel
    confirmDeleteModel(model) {
      this.$confirm('Xác nhận xóa liên hệ: ' + model.name, 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.deleteModel(model)
      }).catch(() => {

      })
    },
    // Xóa bản ghi
    deleteModel(model) {
      axios.delete('contacts/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Xóa bản ghi thành công',
              type: 'success'
            })
            let indexDelete = this.findIDLocal(model)
            if (indexDelete > -1) {
              this.table.database.splice(indexDelete, 1)
            }
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    confirmGiftPotatoForCommentGood(model) {
      this.$confirm('Xác nhận tặng 10 khoai cho comment này', 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.giftPotatoForComment(model)
      }).catch(() => {

      })
    },
    giftPotatoForComment(model) {
      let dataGiftPotatoForComment = {
        'comment_id': model.id
      }
      axios.post('payments/gift-potato-for-comment-good', dataGiftPotatoForComment).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Tặng khoai thành công ghi thành công',
              type: 'success'
            })
            this.$router.push({ name: 'payments-index' })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tìm ID ở database Local để xóa đi
    findIDLocal(model) {
      let index = findIndex(this.table.database, function (o) {
        return o.id === model.id
      })
      return index
    },
    // Thay đổi Current Page
    changeCurrentPage(currentPage) {
      this.filter.page = currentPage
      this.fetchDatabaseModel()
    }
  },
  watch: {
    'filter.status': function () {
      this.fetchDatabaseModel()
    },
    'filter.course_id': function () {
      this.fetchListLesson()
      this.filter.lesson_id = ''
      this.fetchDatabaseModel()
    },
    'filter.lesson_id': function () {
      this.fetchDatabaseModel()
    },
    'filter.q': function () {
      this.searching = true
      clearTimeout(this.timer)
      let _this = this
      this.timer = setTimeout(function () {
        _this.searching = false
        _this.fetchDatabaseModel()
      }, 800)
    },
    'filter.sort': function () {
      this.fetchDatabaseModel()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-filter-search {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #efefef;
  border-radius: 2px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.model-filter-radio {
  margin-bottom: 10px;
}

.model-filter-radio span {
  margin-right: 20px;
  width: 135px;
  display: inline-block;
}

.course-image {
  width: 150px;
  border-radius: 2px;
}

.courses-info {
  display: flex;
  flex-direction: column;
}

.courses-info span {
  margin-bottom: 5px;
}

.courses-info__item {
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/luckywheels/Index.vue